import type { RegistredFeatureflag } from '@src/endpoints/feature.flag'
import React, { useContext } from 'react'
import type { FeatureFlag } from '../models'

function register<
  T extends RegistredFeatureflag,
  U = { [K in T]: FeatureFlag }
>(keys: T[]): (p: U) => U {
  return (p: U) => p
}

const registerFeatureFlags = register([
  'CAM_TEMP_20210127_USE_REPORT_SERVICE',
  'CAM_TEMP_20210817_ALERTS_IMPROVEMENTS',
  'CAM_TEMP_20220209_SOURCES_IMPROVEMENTS',
  'CAM_TEMP_20220216_IDENTITY_TAB_OPTIMIZATIONS',
  'CAM_TEMP_20220623_IDN_LOGIN_PATH',
  'CAM_TEMP_20220920_FIX_NOT_ALLOW_DISABLING_AWS_TOP_ORG_ACCOUNT',
  'CAM_TEMP_20220920_SCOPES_HYERARCHY_PART_SELECTION_FIX',
  'CAM_PERM_20220804_HIDE_RESOURCES_ACCESS',
  'CAM_PERM_20220804_HIDE_DASHBOARD',
  'CAM_PERM_20220804_HIDE_AUTOCOMPLETE',
  'CAM_PERM_20220804_HIDE_ALERTS_GUARDRAILS',
  'CAM_PERM_20220804_HIDE_ALL_SOURCE',
  'CAM_TEMP_20221007_INCREASE_PROGRESS_REQUEST_INTERVAL',
  'CAM_TEMP_20221114_INPUT_TOOLTIP_FIX',
  'CAM_TEMP_20230620_ENABLE_SUPPORT_SNS_TRAIL_ARN'
])

export const RegisteredFeatureFlags = registerFeatureFlags({
  CAM_TEMP_20210127_USE_REPORT_SERVICE: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20210817_ALERTS_IMPROVEMENTS: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20220209_SOURCES_IMPROVEMENTS: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20220216_IDENTITY_TAB_OPTIMIZATIONS: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20220623_IDN_LOGIN_PATH: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20220920_FIX_NOT_ALLOW_DISABLING_AWS_TOP_ORG_ACCOUNT: {
    pending: true,
    response: { value: false }
  },
  CAM_PERM_20220804_HIDE_ALL_SOURCE: {
    pending: true,
    response: { value: false }
  },
  CAM_PERM_20220804_HIDE_RESOURCES_ACCESS: {
    pending: true,
    response: { value: false }
  },
  CAM_PERM_20220804_HIDE_ALERTS_GUARDRAILS: {
    pending: true,
    response: { value: false }
  },
  CAM_PERM_20220804_HIDE_DASHBOARD: {
    pending: true,
    response: { value: false }
  },
  CAM_PERM_20220804_HIDE_AUTOCOMPLETE: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20220920_SCOPES_HYERARCHY_PART_SELECTION_FIX: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20221007_INCREASE_PROGRESS_REQUEST_INTERVAL: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20221114_INPUT_TOOLTIP_FIX: {
    pending: true,
    response: { value: false }
  },
  CAM_TEMP_20230620_ENABLE_SUPPORT_SNS_TRAIL_ARN: {
    pending: true,
    response: { value: false }
  }
})

export const getSourcesAccessSet = () => {
  const set = new Set()
  set.add('sources')
  set.add('Sources')
  set.add('accounts')
  set.add('Changes')
  set.add('changes')
  set.add('dashboard')
  set.add('Dashboard')
  return set
}

export const getResourcesAccessSet = () => {
  const set = new Set()
  set.add('networks')
  set.add('objects')
  set.add('identities')
  set.add('privileges')
  set.add('Privileges')
  set.add('Users')
  set.add('unusedAccess')
  set.add('Unused Access')
  set.add('unused-access')
  return set
}

export const getAlertsuardrailsComplianceAccessSet = () => {
  const set = new Set()
  set.add('alerts')
  set.add('guardrails')
  set.add('compliance')
  return set
}

export type ContextState = {
  [key in keyof typeof RegisteredFeatureFlags]: FeatureFlag
} & { pending: boolean }

const FeatureFlagsContext = React.createContext<Partial<ContextState>>({
  ...RegisteredFeatureFlags,
  pending: true
})

export const FeatureFlagsConsumer = FeatureFlagsContext.Consumer

export const useFeatureFlagsContext = () => useContext(FeatureFlagsContext)

export default FeatureFlagsContext
